import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarArrowLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.2227 5.77734C12.2227 5.39453 11.9492 5.12109 11.5664 5.12109H2.26953L5.90625 1.64844C6.17969 1.40234 6.17969 0.964844 5.93359 0.71875C5.6875 0.445312 5.27734 0.445312 5.00391 0.691406L0.191406 5.28516C0.0546875 5.42188 0 5.58594 0 5.77734C0 5.94141 0.0546875 6.10547 0.191406 6.24219L5.00391 10.8359C5.27734 11.082 5.6875 11.082 5.93359 10.8086C6.17969 10.5625 6.17969 10.125 5.90625 9.87891L2.26953 6.43359H11.5664C11.9492 6.43359 12.2227 6.13281 12.2227 5.77734Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgCalendarArrowLeft);
export { ForwardRef as ReactComponent };
